import React, { Component } from "react";
import styled from "styled-components";
import profilePic from "../../assets/images/profilePic.jpeg";

const ProfilePic = styled.img`
  width: ${props => (props.width ? props.width : "100px")};
  height: ${props => (props.height ? props.height : "100px")};
  border-radius: ${props => (props.bRadius ? props.bRadius : "50%")};
`;

class FotoContacto extends Component {
  render() {
    const alt = "Texto Alternativo";

    return <ProfilePic {...this.props} src={this.props.src ? this.props.src : profilePic} alt={alt} />;
  }
}

export default FotoContacto;
